import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
};

const Divider = ({ className }: Props) => <div className={twMerge('h-0.25 bg-divider w-full', className)} />;

export default Divider;
